// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"150":"424e9c4c","422":"1b8ffb96","556":"c616a5fd","586":"abfffc06","596":"3485e61e"}[chunkId] + ".chunk.css";
};